import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-empty-data',
  templateUrl: './empty-data.component.html',
  styles: [],
})
export class EmptyDataComponent implements OnInit {
  constructor() {}

  @Input() text?: string = '暂无数据';

  ngOnInit() {}
}
